module.exports = __webpack_public_path__ + "media/assets/img/flags/lt-LT-7eb9487d4dac00095f8ed2d2c80b21a8.png";